import moment from 'moment';
import 'moment-timezone';
import { SERVER_TIMEZONE } from '@ally/date-utils';
export function isImmediate(deliveryDate, withdrawalDate) {
    var compareDate = deliveryDate;
    if (withdrawalDate.valueOf() > deliveryDate.valueOf()) {
        compareDate = withdrawalDate;
    }
    return moment().tz(SERVER_TIMEZONE).isSameOrAfter(compareDate, 'days');
}
//# sourceMappingURL=immediate.js.map